import React, { Component } from 'react';
import { 
  Container,
  Header,
  Icon,
} from 'semantic-ui-react';

class CheckoutError extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uid: this.props.match.params.uid,
    };
  }

  render() {
    return (
      <Container className="download">
        <Header as='h3'>
          It seems that an error occurred during the checkout! <Icon name="frown" />
        </Header>
        <p>
        </p>
        <p>
          If you need any support, contact us at <a href={"mailto:contact@strmaker.com?subject=Checkout%20Problem%20" + this.state.uid}>contact@strmaker.com</a>.
          {this.state.uid && <span><br />Provide us this id: {this.state.uid}</span>}
        </p>
        <p>
          Click here to go <a href={process.env.REACT_APP_FRONT_DOMAIN}>back to the creation tool</a>.
        </p>
      </Container>
    )
  }
}

export default CheckoutError;



// WEBPACK FOOTER //
// ./src/CheckoutError.js